import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetTheReinvestmentRetrieveActions,
  SetTheReInvestmentEditsActions,
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import "../../../StyleSheet/MainComponent/REInvesment/ReInvesment.scss";
import { data } from "jquery";

const ReInvesmentEdit = (props) => {
  const { currentPage, setShow, show, EditId , data , selectVal , white_collar  , from_date , to_date , search} = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const initialState = {
    from_date: "",
    to_date: "",

    status: "",

    user_id: "",
    way_type: "",
    wheeler_type: "",
    certificate_id: "",
    client_id: "",
    user_name: "",
    description: "",
    reason_type: "",
    amount: "",
    firstIm: null,
    seconImg: null,
  };
  const [Data, setDatas] = useState(initialState);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  useEffect(() => {
    dispatch(SetTheReinvestmentRetrieveActions({ EditId }));
  }, []);
  useEffect(() => {
   /// console.log(state.reInvestmentRetrieveCall.reinvestmentretrieve, "datas");
    if (state.reInvestmentRetrieveCall.reinvestmentretrieve.id != undefined) {
      const dateString =
        state.reInvestmentRetrieveCall.reinvestmentretrieve.applied_date;
      const dateObject = new Date(dateString);
      const hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      const amOrPm = hours >= 12 ? "PM" : "AM";
      const twelveHourFormat = hours % 12 || 12;
      const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

      setDatas({
        ...Data,
        way_type: state.reInvestmentRetrieveCall.reinvestmentretrieve.way_type,
        wheeler_type:
          state.reInvestmentRetrieveCall.reinvestmentretrieve.wheeler_type,
        reason_type:
          state.reInvestmentRetrieveCall.reinvestmentretrieve.reason_type,
        amount: state.reInvestmentRetrieveCall.reinvestmentretrieve.amount,
        status: state.reInvestmentRetrieveCall.reinvestmentretrieve.status,
        from_date: state.reInvestmentRetrieveCall.reinvestmentretrieve.for_date,

        notes: state.reInvestmentRetrieveCall.reinvestmentretrieve.notes,
        user_name:
          state.reInvestmentRetrieveCall.reinvestmentretrieve.user_id
            .first_name,
        client_id:
          state.reInvestmentRetrieveCall.reinvestmentretrieve.client_id != null ?
          state.reInvestmentRetrieveCall.reinvestmentretrieve.client_name :"",
        description:
          state.reInvestmentRetrieveCall.reinvestmentretrieve
            .reason_for_decline,

        // applied_date:
        // state.reInvestmentRetrieveCall.reinvestmentretrieve.applied_date.slice(
        // 0,
        // 10
        // ) +
        // "  " +
        // formattedTime,
      });
    }
  }, [state.reInvestmentRetrieveCall.reinvestmentretrieve]);
  const HandleChanges = (e) => {
    setDatas({
      ...Data,
      status: e.target.value,
    });
  };
  const HandleDecriptions = (e) => {
    setDatas({
      ...Data,
      description: e.target.value,
    });
  };

  const handleClose = () => {
    setShow(false);
  };
  const HandleClick = () => {
    const payload = {
      status: Data.status.toLowerCase(),
      description:
      Data.status.toLowerCase() == "decline" ? Data.description : "",
      //description: Data.description,
      EditId: EditId,
      currentPage: currentPage,
      data:data,
      selectVal:selectVal,
      white_collar:white_collar, 
      // month: Datestate.month,
      //   year: Datestate.year,
      //   date:Datestate.date , 
      from_date:from_date, to_date:to_date , 
      search:search,
    };
    dispatch(SetTheReInvestmentEditsActions(payload, props.setShow()));
  };
  const Options = [
    {
      id: 1,
      Status: "Approved",
    },
    {
      id: 2,
      Status: "Decline",
    },
    {
      id: 3,
      Status: "Pending",
    },
  ];
  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>Reimbursement</span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyUserCRUD">
                      <div className="row">
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.user_name}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        {/* <div className="col-6 mt-3"> */}
                        {/* <label for="validationCustom01" class="form-label"> */}
                        {/* Applied date */}
                        {/* </label> */}
                        {/* <input */}
                        {/* // type="text" */}
                        {/* // class="form-control" */}
                        {/* // id="validationCustom01" */}
                        {/* // autocomplete="off" */}
                        {/* // name="first_name" */}
                        {/* // value={Data.applied_date} */}
                        {/* // readOnly */}
                        {/* // /> */}
                        {/* </div> */}
                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Reason
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="first_name"
                            value={Data.reason_type}
                            readOnly
                          />
                        </div>
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Way Type
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.way_type}
                            name="last_name"
                            readOnly
                          />
                        </div>
                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Client name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.client_id}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Wheeler Type
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="first_name"
                            value={Data.wheeler_type}
                            readOnly
                          />
                        </div>
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Amount
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.amount}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            From
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="name"
                            value={Data.from_date}
                            readOnly
                          />
                        </div>
                      


                        <div className="row" style={{padding:"20px" , marginLeft:"10px" }}>
                          {state.reInvestmentRetrieveCall.reinvestmentretrieve
                            .documents ? (
                            <>
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >Document</label>
                              <div className="col mt-3 BefoereImageView">
                                {state.reInvestmentRetrieveCall.reinvestmentretrieve.documents.map(
                                  (item, indes) => (
                                    <>
                                      <div className="ImagesList">
                                        <a
                                          onClick={(e) =>
                                            window.open(item.media_url)
                                          }
                                          target="blank"
                                          style={{ cursor: "pointer" }}
                                          download={item.media_url}
                                        >
                                          <img src={item.media_url} />
                                        </a>
                                      </div>
                                    </>
                                  )
                                )}
                              </div>
                            </>
                          ) : (
                                 null
                          )}
                        </div>
                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Status
                          </label>

                          <select
                            class="form-select form-select-lg col-12"
                            aria-label=".form-select-lg example"
                            onChange={HandleChanges}
                            /// value={Data.status}
                          >
                            {Options.map((item) => (
                              <option
                                selected={
                                  Data.status.toLowerCase() ==
                                  item.Status.toLowerCase()
                                }
                                value={item.Status}
                              >
                                {item.Status}
                              </option>
                            ))}
                          </select>
                        </div>
                        {Data.status.toLowerCase() == "decline" ? (
                          <>
                            <div className="col-sm-3" style={{ width: "700px" }}>
                              <br/>
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                  Reason for decline
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                required
                                autocomplete="off"
                                name="description"
                                value={Data.description}
                                onChange={HandleDecriptions}
                              />
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>

                    <div className="UserButtons">
                      <button
                        class="btn  SaveBtn"
                        type="submit"
                        onClick={(e) => {
                          HandleClick(e);
                        }}
                        disabled={
                          state.reInvestmentRetrieveCall.reinvestmentretrieve
                            .status == Data.status.toLowerCase()
                        }

                      >
                        Submit
                      </button>
                      <button
                        class="btn CancelBtn"
                        onClick={(e) => handleClose(e)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReInvesmentEdit;
